const FIRST_HEADING = "Discover";
const SECOND_HEADING = "Explore Other Tastes of The World";

export { FIRST_HEADING, SECOND_HEADING };
